<template>
    <div class="My_popup">
        <div class="My_popup_wrap">
            <span class="My_popup_close"><a href="#" @click.prevent="closeClickHandle">닫기</a></span>
            <div class="My-popup-title"><span class="color-skyblue">대기환경</span></div>
            <div class="air-map">
                <DrawRegionNaverMap />
            </div>
            <div class="My-popup-content">
                <div class="air-pop">
                    <div class="pop_title">{{ selectedAirType !== '' ? airQaMetaObj[selectedAirType].name : '' }} 기준</div>

                    <ul class="air-chart-bar" v-if="selectedAirType === 'pm10'">
                        <li>좋음<p>0~30</p>
                        </li>
                        <li>보통<p>31~80</p>
                        </li>
                        <li>나쁨<p>81~150</p>
                        </li>
                        <li>매우나쁨<p>150~</p>
                        </li>
                        <li>정보없음</li>
                    </ul>
                    <ul class="air-chart-bar" v-else-if="selectedAirType === 'pm25'">
                        <li>좋음<p>0~15</p>
                        </li>
                        <li>보통<p>16~35</p>
                        </li>
                        <li>나쁨<p>36~75</p>
                        </li>
                        <li>매우나쁨<p>76~</p>
                        </li>
                        <li>정보없음</li>
                    </ul>
                    <ul class="air-chart-bar" v-else-if="selectedAirType === 'no2'">
                        <li>좋음<p>0~0.030</p>
                        </li>
                        <li>보통<p>0.031~<br />0.060</p>
                        </li>
                        <li>나쁨<p>0.061~<br />0.200</p>
                        </li>
                        <li>매우나쁨<p>0.201~</p>
                        </li>
                        <li>정보없음</li>
                    </ul>
                    <ul class="air-chart-bar" v-else-if="selectedAirType === 'o3'">
                        <li>좋음<p>0~0.030</p>
                        </li>
                        <li>보통<p>0.031~<br />0.090</p>
                        </li>
                        <li>나쁨<p>0.091~<br />0.150</p>
                        </li>
                        <li>매우나쁨<p>0.151~</p>
                        </li>
                        <li>정보없음</li>
                    </ul>


                    <div :class="['pop_btn_black2', {'active': selectedAirType === 'pm10'}]">
                        <a href="#" @click.prevent="selectAirType('pm10')">미세먼지</a>
                    </div>&nbsp;&nbsp;
                    <div :class="['pop_btn_black2', {'active': selectedAirType === 'pm25'}]">
                        <a href="#" @click.prevent="selectAirType('pm25')">초미세먼지</a>
                    </div>&nbsp;&nbsp;
                    <div :class="['pop_btn_black2', {'active': selectedAirType === 'no2'}]">
                        <a href="#" @click.prevent="selectAirType('no2')">이산화질소</a>
                    </div>&nbsp;&nbsp;
                    <div :class="['pop_btn_black2', {'active': selectedAirType === 'o3'}]">
                        <a href="#" @click.prevent="selectAirType('o3')">오존</a>
                    </div>&nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import airLevel from "@/lib/air.level.js";
import DrawRegionNaverMap from "@/components/DrawRegionNaverMap.vue";

export default {
    name: 'AirMapWin',
    data: function() {
        return {
            selectedAirType: '',
            geoJsonDrawing: undefined,
            airQaMetaObj: {
                pm10: { name: '미세먼지', valCol: 'val8', levCol: 'val9', levelFun: airLevel.pm10Level },
                pm25: { name: '초미세먼지', valCol: 'val10', levCol: 'val11', levelFun: airLevel.pm25Level },
                no2: { name: '이산화질소', valCol: 'val14', levCol: 'val15', levelFun: airLevel.no2Level },
                o3: { name: '오존', valCol: 'val12', levCol: 'val13', levelFun: airLevel.o3Level },
            }
        }
    },
    computed: {
        ...mapGetters({
            airHjdMap: 'getAirHjdMap',
        }),
    },
    watch: {
        airHjdMap: {
            immediate: false,
            handler(newVal, oldVal) {
                this.airQa();
            }
        }
    },
    created() {
        this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
            this.geoJsonDrawing = geoJsonDrawing;
            this.selectAirType('pm10');
        });
    },
    methods: {
        closeClickHandle() {
            this.$emit("close-air-map-win");
        },
        selectAirType: function(airType) {
            this.selectedAirType = airType;
            this.airQa();
        },
        airQa() {
            if (typeof this.geoJsonDrawing !== $WC.UNDEF && this.selectedAirType !== '') {
                this.geoJsonDrawing.setDefaultFillColor();
                let airQaMeta = this.airQaMetaObj[this.selectedAirType];

                if (typeof airQaMeta !== $WC.UNDEF) {
                    for (let hjdCd in this.airHjdMap) {
                        let val = this.airHjdMap[hjdCd][airQaMeta.valCol];
                        let level = airQaMeta.levelFun.call(this, val);
                        var fillColor = airLevel.getAirQaColor(level[0]);
                        this.geoJsonDrawing.setFillColor(hjdCd, fillColor);
                    }
                }
            }
        }
    },
    components: {
        DrawRegionNaverMap,
    }
}
</script>